import { httpRequest } from '@common/util/api-common.util';

export default class LaudoApi {
  static getLaudo (laudoId) {
    return httpRequest(`laudos/1/1?laudo=${laudoId}`).then(json => json.data);
  }

  static obterBasePdf64String (laudoId, etapa) {
    return httpRequest(`imprimir/preview/pdf/${etapa}/${laudoId}`).then(
      json => json.data
    );
  }

  static obterBasePdf64StringByRtf (laudoId, etapa, rtfString) {
    return httpRequest(`imprimir/preview/pdf`, 'POST', {
      laudoId,
      etapa,
      rtfString
    }).then(json => json.data);
  }
}



// WEBPACK FOOTER //
// ./src/pages/laudo/laudo.api.js